export const i18n: Record<string, Record<string, any>> = {
    us: {
        view_more: 'View More',
        view_less: 'View Less',

        view_steps: 'View Steps',
        view_step_modal_title: 'Rules:',

        unlock_title: 'Ready to Unlock?',
        unlock_desc: 'Unlock the Event with XX EcoCredits!',
        unlock_btn_cancel: 'Cancel',
        unlock_btn_ok: 'Confirm',

        email_btn: 'Subscribe',
        email_placeholder: 'Drop Your Email',
        email_tips_empty: 'Please enter the email address.',
        email_tips_type_error: 'Please enter a valid email address.',
        email_success_tips: 'Sign up successful.',
        email_tips_check: 'Please agree to the Terms of Use and Privacy Policy.',
        email_terms:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-us/TermsOfUse.html" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',

        countdown_day: 'DAY',
        countdown_days: 'DAYS',
        countdown_hour: 'HOUR',
        countdown_hours: 'HOURS',
        countdown_minute: 'MINUTE',
        countdown_minutes: 'MINUTES',
        countdown_second: 'SECOND',
        countdown_seconds: 'SECONDS',

        card_sold: 'Sold: ',
        card_stock: 'Stock: ',
        card_btn_coming_soon: 'Coming Soon',
        card_btn_learn_more: 'Learn More',
        card_btn_buy_now: 'Buy Now',
        card_btn_add_cart: 'Add to Cart',
        card_btn_sold_out: 'Sold Out',
        card_inventory_left: '{num} Left',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' OFF',
        card_non_member_price: 'Non-member price',
        card_price_tax: '',
    },
    ca: {
        view_more: 'View More',
        view_less: 'View Less',

        view_steps: 'View Steps',
        view_step_modal_title: 'Rules:',

        unlock_title: 'Ready to Unlock?',
        unlock_desc: 'Unlock the Event with XX EcoCredits!',
        unlock_btn_cancel: 'Cancel',
        unlock_btn_ok: 'Confirm',

        email_btn: 'Subscribe',
        email_placeholder: 'Drop Your Email',
        email_tips_empty: 'Please enter the email address.',
        email_tips_type_error: 'Please enter a valid email address.',
        email_success_tips: 'Sign up successful.',
        email_tips_check: 'Please agree to the Terms of Use and Privacy Policy.',
        email_terms:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-ca/TermsOfUse.html" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',

        countdown_day: 'DAY',
        countdown_days: 'DAYS',
        countdown_hour: 'HOUR',
        countdown_hours: 'HOURS',
        countdown_minute: 'MINUTE',
        countdown_minutes: 'MINUTES',
        countdown_second: 'SECOND',
        countdown_seconds: 'SECONDS',

        card_sold: 'Sold: ',
        card_stock: 'Stock: ',
        card_btn_coming_soon: 'Coming Soon',
        card_btn_learn_more: 'Learn More',
        card_btn_buy_now: 'Buy Now',
        card_btn_add_cart: 'Add to Cart',
        card_btn_sold_out: 'Sold Out',
        card_inventory_left: '{num} Left',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' OFF',
        card_non_member_price: 'Non-member price',
        card_price_tax: '',
    },
    eu: {
        view_more: 'View More',
        view_less: 'View Less',

        view_steps: 'View Steps',
        view_step_modal_title: 'Rules:',

        unlock_title: 'Ready to Unlock?',
        unlock_desc: 'Unlock the Event with XX EcoCredits!',
        unlock_btn_cancel: 'Cancel',
        unlock_btn_ok: 'Confirm',

        email_btn: 'Subscribe',
        email_placeholder: 'Drop Your Email',
        email_tips_empty: 'Please enter the email address.',
        email_tips_type_error: 'Please enter a valid email address.',
        email_success_tips: 'Sign up successful.',
        email_tips_check: 'Please agree to the Terms of Use and Privacy Policy.',
        email_terms:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-eu/TermsOfUse.html" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-eu/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',

        countdown_day: 'DAY',
        countdown_days: 'DAYS',
        countdown_hour: 'HOUR',
        countdown_hours: 'HOURS',
        countdown_minute: 'MINUTE',
        countdown_minutes: 'MINUTES',
        countdown_second: 'SECOND',
        countdown_seconds: 'SECONDS',

        card_sold: 'Sold: ',
        card_stock: 'Stock: ',
        card_btn_coming_soon: 'Coming Soon',
        card_btn_learn_more: 'Learn More',
        card_btn_buy_now: 'Buy Now',
        card_btn_add_cart: 'Add to Cart',
        card_btn_sold_out: 'Sold Out',
        card_inventory_left: '{num} Left',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' OFF',
        card_non_member_price: 'Non-member price',
        card_price_tax: '',
    },
    uk: {
        view_more: 'View More',
        view_less: 'View Less',

        view_steps: 'View Steps',
        view_step_modal_title: 'Rules:',

        unlock_title: 'Ready to Unlock?',
        unlock_desc: 'Unlock the Event with XX EcoCredits!',
        unlock_btn_cancel: 'Cancel',
        unlock_btn_ok: 'Confirm',

        email_btn: 'Subscribe',
        email_placeholder: 'Drop Your Email',
        email_tips_empty: 'Please enter the email address.',
        email_tips_type_error: 'Please enter a valid email address.',
        email_success_tips: 'Sign up successful.',
        email_tips_check: 'Please agree to the Terms of Use and Privacy Policy.',
        email_terms:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-uk/TermsOfUse.html" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-uk/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',

        countdown_day: 'DAY',
        countdown_days: 'DAYS',
        countdown_hour: 'HOUR',
        countdown_hours: 'HOURS',
        countdown_minute: 'MINUTE',
        countdown_minutes: 'MINUTES',
        countdown_second: 'SECOND',
        countdown_seconds: 'SECONDS',

        card_sold: 'Sold: ',
        card_stock: 'Stock: ',
        card_btn_coming_soon: 'Coming Soon',
        card_btn_learn_more: 'Learn More',
        card_btn_buy_now: 'Buy Now',
        card_btn_add_cart: 'Add to Cart',
        card_btn_sold_out: 'Sold Out',
        card_inventory_left: '{num} Left',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' OFF',
        card_non_member_price: 'Non-member price',
        card_price_tax: '',
    },
    de: {
        view_more: 'Mehr anzeigen',
        view_less: 'Weniger anzeigen',

        view_steps: 'Mehr anzeigen',
        view_step_modal_title: 'Regeln:',

        unlock_title: 'Freischalten?',
        unlock_desc: 'Event mit XX EcoCredits freischalten!',
        unlock_btn_cancel: 'Abbrechen',
        unlock_btn_ok: 'Bestätigen',

        email_btn: 'Abonnieren',
        email_placeholder: 'E-Mail Adresse eingeben',
        email_tips_empty: 'Bitte geben Sie die E-Mail Adresse ein.',
        email_tips_type_error: 'Bitte geben Sie eine gültige E-Mail Adresse ein.',
        email_success_tips: 'Registrierung erfolgreich',
        email_tips_check: 'Bitte stimmen Sie den Nutzungsbedingungen und der Datenschutzrichtlinie zu.',
        email_terms:
            'Ich stimme den <a href="https://account.ecoflow.com/agreement/de-de/TermsOfUse.html" target="_blank">Nutzungsbedingungen</a> und der <a href="https://account.ecoflow.com/agreement/de-de/PrivacyPolicy.html" target="_blank">Datenschutzrichtlinie</a> zu.',

        countdown_day: 'TAG',
        countdown_days: 'TAGE',
        countdown_hour: 'STUNDE',
        countdown_hours: 'STUNDEN',
        countdown_minute: 'MINUTE',
        countdown_minutes: 'MINUTEN',
        countdown_second: 'ZWEITE',
        countdown_seconds: 'SEKUNDEN',

        card_sold: 'Verkauft: ',
        card_stock: 'Lagerbestand: ',
        card_btn_coming_soon: 'Demnächst erhältlich',
        card_btn_learn_more: 'Mehr erfahren',
        card_btn_buy_now: 'Jetzt kaufen',
        card_btn_add_cart: 'Zum Warenkorb hinzufügen',
        card_btn_sold_out: 'Ausverkauft',
        card_inventory_left: '{num} verfügbar',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' Rabatt',
        card_non_member_price: 'Preis für Nicht-Mitglieder',
        card_price_tax: '',
    },
    fr: {
        view_more: 'Afficher plus',
        view_less: 'Afficher moins',

        view_steps: 'Afficher plus',
        view_step_modal_title: "Consultez les détails de l'offre:",

        unlock_title: 'Prêt à débloquer cet événement ?',
        unlock_desc: 'Utilisez XX EcoCredits pour le débloquer !',
        unlock_btn_cancel: 'Annuler',
        unlock_btn_ok: 'Confirmer',

        email_btn: "S'abonner",
        email_placeholder: 'Adresse e-mail',
        email_tips_empty: 'Veuillez saisir votre adresse e-mail.',
        email_tips_type_error: 'Veuillez saisir une adresse e-mail valide.',
        email_success_tips: 'Inscription réussie.',
        email_tips_check: "Veuillez accepter les Conditions d'utilisation et la Politique de confidentialité.",
        email_terms:
            'J\'accepte les <a href="https://account.ecoflow.com/agreement/fr-fr/TermsOfUse.html" target="_blank">Conditions d\'utilisation</a> et <a href="https://account.ecoflow.com/agreement/fr-fr/PrivacyPolicy.html" target="_blank">la Politique de confidentialité</a>.',

        countdown_day: 'JOUR',
        countdown_days: 'JOURS',
        countdown_hour: 'HEURE',
        countdown_hours: 'HEURES',
        countdown_minute: 'MINUTE',
        countdown_minutes: 'MINUTES',
        countdown_second: 'SECONDE',
        countdown_seconds: 'SECONDES',

        card_sold: 'Vendu: ',
        card_stock: 'Stock: ',
        card_btn_coming_soon: 'Bientôt disponible',
        card_btn_learn_more: 'En savoir plus',
        card_btn_buy_now: 'Acheter',
        card_btn_add_cart: 'Ajouter au panier',
        card_btn_sold_out: 'Épuisé',
        card_inventory_left: '{num} restants',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' Économisez',
        card_non_member_price: 'Prix non-membre',
        card_price_tax: '',
    },
    it: {
        view_more: 'Mostra di più',
        view_less: 'Mostra meno',

        view_steps: 'Visualizza i passaggi',
        view_step_modal_title: 'Regole:',

        unlock_title: 'Sblocca subito i tuoi premi',
        unlock_desc: 'Sblocca l’evento con XX EcoCredits!',
        unlock_btn_cancel: 'Annulla',
        unlock_btn_ok: 'Conferma',

        email_btn: 'Iscriviti',
        email_placeholder: 'Comunicaci il tuo indirizzo e-mail',
        email_tips_empty: 'Inserisci l’indirizzo e-mail.',
        email_tips_type_error: 'Inserisci un indirizzo e-mail valido.',
        email_success_tips: 'Iscrizione riuscita.',
        email_tips_check: 'Accetta i Termini di utilizzo e l’Informativa sulla privacy.',
        email_terms:
            'Accetto i <a href="https://account.ecoflow.com/agreement/it-it/TermsOfUse.html" target="_blank">Termini di utilizzo</a> e <a href="https://account.ecoflow.com/agreement/it-it/PrivacyPolicy.html" target="_blank">l\'Informativa sulla privacy</a>.',

        countdown_day: 'GIORNO',
        countdown_days: 'GIORNI',
        countdown_hour: 'ORA',
        countdown_hours: 'ORE',
        countdown_minute: 'MINUTO',
        countdown_minutes: 'MINUTI',
        countdown_second: 'SECONDO',
        countdown_seconds: 'SECONDI',

        card_sold: 'VendutiScorte: ',
        card_stock: 'Scorte: ',
        card_btn_coming_soon: 'In arrivo',
        card_btn_learn_more: 'Scopri di più',
        card_btn_buy_now: 'Acquista ora',
        card_btn_add_cart: 'Aggiungi al carrello',
        card_btn_sold_out: 'Esaurito',
        card_inventory_left: '{num} rimasti',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' SCONTO',
        card_non_member_price: 'Prezzo non socio',
        card_price_tax: '',
    },
    es: {
        view_more: 'Ver más',
        view_less: 'Ver menos',

        view_steps: 'Ver pasos',
        view_step_modal_title: 'Reglas:',

        unlock_title: '¿Estás listo para unirte al evento?',
        unlock_desc: '¡Únete al evento con XX EcoCredits!',
        unlock_btn_cancel: 'Cancelar',
        unlock_btn_ok: 'Confirmar',

        email_btn: 'Suscribirse',
        email_placeholder: 'Ingresa tu correo electrónico',
        email_tips_empty: 'Escribe tu dirección de correo electrónico',
        email_tips_type_error: 'Escribe una dirección de correo electrónico válida.',
        email_success_tips: 'Registro exitoso.',
        email_tips_check: 'Acepta los Términos de uso y la Política de privacidad.',
        email_terms:
            'Acepto los <a href="https://account.ecoflow.com/agreement/es-es/TermsOfUse.html" target="_blank">Términos de uso</a> y la <a href="https://account.ecoflow.com/agreement/es-es/PrivacyPolicy.html" target="_blank">Política de privacidad</a>.',

        countdown_day: 'DÍA',
        countdown_days: 'DÍAS',
        countdown_hour: 'HORA',
        countdown_hours: 'HORAS',
        countdown_minute: 'MINUTO',
        countdown_minutes: 'MINUTOS',
        countdown_second: 'SEGUNDO',
        countdown_seconds: 'SEGUNDOS',

        card_sold: 'Vendido: ',
        card_stock: 'Existencias: ',
        card_btn_coming_soon: 'Próximamente',
        card_btn_learn_more: 'Más información',
        card_btn_buy_now: 'Comprar ahora',
        card_btn_add_cart: 'Añadir al carrito',
        card_btn_sold_out: 'Agotado',
        card_inventory_left: '{num} quedan',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' DESACTIVAR',
        card_non_member_price: 'Precio para no miembros',
        card_price_tax: '',
    },
    jp: {
        view_more: 'さらに見る',
        view_less: '少なく表示する',

        view_steps: '手順を確認',
        view_step_modal_title: '条件：',

        unlock_title: 'セールに参加する用意はできていますか？',
        unlock_desc: 'XXエコポイントを使いセールに参加',
        unlock_btn_cancel: 'キャンセル',
        unlock_btn_ok: '確認',

        email_btn: '登録する',
        email_placeholder: 'メールアドレス',
        email_tips_empty: 'メールアドレスを入力してください',
        email_tips_type_error: '有効なメールアドレスを入力してください（例：name@domain.com）',
        email_success_tips: 'ご登録ありがとうございます！',
        email_tips_check: '「EcoFlowのプライバシーポリシーと利用規約に同意する」にチェックを入れてください',
        email_terms:
            '<a href="https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html" target="_blank">利用規約</a>と<a href="https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html" target="_blank">プライバシーポリシー</a>に同意します。',

        countdown_day: '日',
        countdown_days: '日',
        countdown_hour: '時間',
        countdown_hours: '時間',
        countdown_minute: '分',
        countdown_minutes: '分',
        countdown_second: '秒',
        countdown_seconds: '秒',

        card_sold: '売れた: ',
        card_stock: '在庫: ',
        card_btn_coming_soon: 'まもなく公開',
        card_btn_learn_more: 'さらに詳しく',
        card_btn_buy_now: '今すぐ購入',
        card_btn_add_cart: 'カートに入れる',
        card_btn_sold_out: '売り切れ',
        card_inventory_left: '残り{num}個',
        card_tag_times: '倍',
        card_tag_point: 'エコポイント',
        card_tag_off: ' OFF',
        card_non_member_price: '非会員価格',
        card_price_tax: '（税込）',
    },
    kr: {
        view_more: '더 보기',
        view_less: '작게 보기 ',

        view_steps: '절차 확인하기',
        view_step_modal_title: '규칙：',

        unlock_title: '세일에 참여할 준비가 되셨나요?',
        unlock_desc: 'XX 에코포인트를 사용하여 세일에 참여하기',
        unlock_btn_cancel: '취소',
        unlock_btn_ok: '확인',

        email_btn: '구독',
        email_placeholder: '이메일 주소',
        email_tips_empty: '이메일 주소를 입력해 주세요.',
        email_tips_type_error: '올바른 이메일 주소를 입력해 주세요.',
        email_success_tips: '성공적으로 가입됩니다',
        email_tips_check: '이용약관 및 개인정보 취급방침에 동의하십시오.',
        email_terms:
            '<a href="https://account.ecoflow.com/agreement/ko-kr/TermsOfUse.html" target="_blank">개인정보 보호정책</a> 및 <a href="https://account.ecoflow.com/agreement/ko-kr/PrivacyPolicy.html" target="_blank">이용약관에</a> 동의합니다.',

        countdown_day: '일',
        countdown_days: '일',
        countdown_hour: '시',
        countdown_hours: '시',
        countdown_minute: '분',
        countdown_minutes: '분',
        countdown_second: '초',
        countdown_seconds: '초',

        card_sold: '판매됨: ',
        card_stock: '재고: ',
        card_btn_coming_soon: '곧 출시 예정',
        card_btn_learn_more: '더 알아보기',
        card_btn_buy_now: '바로 구매하기',
        card_btn_add_cart: '장바구니 담기',
        card_btn_sold_out: '품절',
        card_inventory_left: '{num}개 남음',
        card_tag_times: '배',
        card_tag_point: '에코포인트',
        card_tag_off: ' 할인',
        card_non_member_price: '비회원 가격',
        card_price_tax: '',
    },
    za: {
        view_more: 'View More',
        view_less: 'View Less',

        view_steps: 'View Steps',
        view_step_modal_title: 'Rules:',

        unlock_title: 'Ready to Unlock?',
        unlock_desc: 'Unlock the Event with XX EcoCredits!',
        unlock_btn_cancel: 'Cancel',
        unlock_btn_ok: 'Confirm',

        email_btn: 'Subscribe',
        email_placeholder: 'Drop Your Email',
        email_tips_empty: 'Please enter the email address.',
        email_tips_type_error: 'Please enter a valid email address.',
        email_success_tips: 'Sign up successful.',
        email_tips_check: 'Please agree to the Terms of Use and Privacy Policy.',
        email_terms:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-za/TermsOfUse.html" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-za/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',

        countdown_day: 'DAY',
        countdown_days: 'DAYS',
        countdown_hour: 'HOUR',
        countdown_hours: 'HOURS',
        countdown_minute: 'MINUTE',
        countdown_minutes: 'MINUTES',
        countdown_second: 'SECOND',
        countdown_seconds: 'SECONDS',

        card_sold: 'Sold: ',
        card_stock: 'Stock: ',
        card_btn_coming_soon: 'Coming Soon',
        card_btn_learn_more: 'Learn More',
        card_btn_buy_now: 'Buy Now',
        card_btn_add_cart: 'Add to Cart',
        card_btn_sold_out: 'Sold Out',
        card_inventory_left: '{num} Left',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' OFF',
        card_non_member_price: 'Non-member price',
        card_price_tax: '',
    },
    au: {
        view_more: 'View More',
        view_less: 'View Less',

        view_steps: 'View Steps',
        view_step_modal_title: 'Rules:',

        unlock_title: 'Ready to Unlock?',
        unlock_desc: 'Unlock the Event with XX EcoCredits!',
        unlock_btn_cancel: 'Cancel',
        unlock_btn_ok: 'Confirm',

        email_btn: 'Subscribe',
        email_placeholder: 'Drop Your Email',
        email_tips_empty: 'Please enter the email address.',
        email_tips_type_error: 'Please enter a valid email address.',
        email_success_tips: 'Sign up successful.',
        email_tips_check: 'Please agree to the Terms of Use and Privacy Policy.',
        email_terms:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-au/TermsOfUse.html" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-au/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',

        countdown_day: 'DAY',
        countdown_days: 'DAYS',
        countdown_hour: 'HOUR',
        countdown_hours: 'HOURS',
        countdown_minute: 'MINUTE',
        countdown_minutes: 'MINUTES',
        countdown_second: 'SECOND',
        countdown_seconds: 'SECONDS',

        card_sold: 'Sold: ',
        card_stock: 'Stock: ',
        card_btn_coming_soon: 'Coming Soon',
        card_btn_learn_more: 'Learn More',
        card_btn_buy_now: 'Buy Now',
        card_btn_add_cart: 'Add to Cart',
        card_btn_sold_out: 'Sold Out',
        card_inventory_left: '{num} Left',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' OFF',
        card_non_member_price: 'Non-member price',
        card_price_tax: '',
    },
    br: {
        view_more: 'Ver mais',
        view_less: 'Ver menos',

        view_steps: 'VVer etapas',
        view_step_modal_title: 'Regras:',

        unlock_title: 'Ready to Unlock?',
        unlock_desc: 'Unlock the Event with XX EcoCredits!',
        unlock_btn_cancel: 'Cancel',
        unlock_btn_ok: 'Confirm',

        email_btn: 'Assine',
        email_placeholder: 'Deixe seu e-mail',
        email_tips_empty: 'Insira o endereço de e-mail válido.',
        email_tips_type_error: 'Insira um endereço de e-mail válido.',
        email_success_tips: 'Inscrição feita com sucesso.',
        email_tips_check: 'Concorde com os Termos de Uso e com a Política de Privacidade.',
        email_terms:
            'Eu concordo com os Termos de Uso e com a <a href="https://account.ecoflow.com/agreement/pt-br/TermsOfUse.html" target="_blank">Política</a> de <a href="https://account.ecoflow.com/agreement/pt-br/PrivacyPolicy.html" target="_blank">Privacidade</a>.',

        countdown_day: 'DIA',
        countdown_days: 'DIAS',
        countdown_hour: 'HORA',
        countdown_hours: 'HORAS',
        countdown_minute: 'MINUTO',
        countdown_minutes: 'MINUTOS',
        countdown_second: 'SEGUNDO',
        countdown_seconds: 'SEGUNDOS',

        card_sold: 'Vendido: ',
        card_stock: 'Existencia: ',
        card_btn_coming_soon: 'Em breve',
        card_btn_learn_more: 'Saiba mais',
        card_btn_buy_now: 'Comprar agora',
        card_btn_add_cart: 'Adicionar ao carrinho',
        card_btn_sold_out: 'Vendidos',
        card_inventory_left: '{num} restante',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' DESCONTO',
        card_non_member_price: 'preço para não membros',
        card_price_tax: '',
    },
    mx: {
        view_more: 'Ver más',
        view_less: 'Ver menos',

        view_steps: 'Ver pasos',
        view_step_modal_title: 'Reglas:',

        unlock_title: 'Ready to Unlock?',
        unlock_desc: 'Unlock the Event with XX EcoCredits!',
        unlock_btn_cancel: 'Cancel',
        unlock_btn_ok: 'Confirm',

        email_btn: 'Suscribirse',
        email_placeholder: 'Ingresa tu correo electrónico',
        email_tips_empty: 'Ingresa tu dirección de correo electrónico.',
        email_tips_type_error: 'Ingresa una dirección de correo electrónico válida.',
        email_success_tips: 'Suscripción correcta.',
        email_tips_check: 'Acepta los Términos de uso y la Política de privacidad.',
        email_terms:
            'Acepto los <a href="https://account.ecoflow.com/agreement/es-mx/TermsOfUse.html" target="_blank">Términos de uso</a> y la  <a href="https://account.ecoflow.com/agreement/es-mx/PrivacyPolicy.html" target="_blank">Política de privacidad</a>.',

        countdown_day: 'DÍA',
        countdown_days: 'DÍAS',
        countdown_hour: 'HORA',
        countdown_hours: 'HORAS',
        countdown_minute: 'MINUTO',
        countdown_minutes: 'MINUTOS',
        countdown_second: 'SEGUNDO',
        countdown_seconds: 'SEGUNDOS',

        card_sold: 'Vendido: ',
        card_stock: 'Existencia: ',
        card_btn_coming_soon: 'Próximamente',
        card_btn_learn_more: 'Más información',
        card_btn_buy_now: 'Comprar ahora',
        card_btn_add_cart: 'Añadir al carrito',
        card_btn_sold_out: 'Agotado',
        card_inventory_left: '{num} restantes',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' DESCUENTO',
        card_non_member_price: 'Precio para no miembros',
        card_price_tax: '',
    },
    ph: {
        view_more: 'View More',
        view_less: 'View Less',

        view_steps: 'View Steps',
        view_step_modal_title: 'Rules:',

        unlock_title: 'Ready to Unlock?',
        unlock_desc: 'Unlock the Event with XX EcoCredits!',
        unlock_btn_cancel: 'Cancel',
        unlock_btn_ok: 'Confirm',

        email_btn: 'Subscribe',
        email_placeholder: 'Drop Your Email',
        email_tips_empty: 'Please enter the email address.',
        email_tips_type_error: 'Please enter a valid email address.',
        email_success_tips: 'Sign up successful.',
        email_tips_check: 'Please agree to the Terms of Use and Privacy Policy.',
        email_terms:
            'I agree to the <a href="https://account.ecoflow.com/agreement/en-ph/TermsOfUse.html" target="_blank">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-ph/PrivacyPolicy.html" target="_blank">Privacy Policy</a>.',

        countdown_day: 'DAY',
        countdown_days: 'DAYS',
        countdown_hour: 'HOUR',
        countdown_hours: 'HOURS',
        countdown_minute: 'MINUTE',
        countdown_minutes: 'MINUTES',
        countdown_second: 'SECOND',
        countdown_seconds: 'SECONDS',

        card_sold: 'Sold: ',
        card_stock: 'Stock: ',
        card_btn_coming_soon: 'Coming Soon',
        card_btn_learn_more: 'Learn More',
        card_btn_buy_now: 'Buy Now',
        card_btn_add_cart: 'Add to Cart',
        card_btn_sold_out: 'Sold Out',
        card_inventory_left: '{num} Left',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' OFF',
        card_non_member_price: 'Non-member price',
        card_price_tax: '',
    },
    nl: {
        view_more: 'Meer bekijken',
        view_less: 'Minder bekijken',

        view_steps: 'Stappen bekijken',
        view_step_modal_title: 'Regels:',

        unlock_title: 'Klaar om te ontgrendelen?',
        unlock_desc: 'Ontgrendel het evenement met XX EcoCredits!',
        unlock_btn_cancel: 'Annuleren',
        unlock_btn_ok: 'Bevestigen',

        email_btn: 'Abonneren',
        email_placeholder: 'Vul uw e-mailadres in',
        email_tips_empty: 'Voer het e-mailadres in.',
        email_tips_type_error: 'Voer een geldig e-mailadres in.',
        email_success_tips: 'Aanmelding succesvol.',
        email_tips_check: 'Ga akkoord met de Gebruiksvoorwaarden en het Privacybeleid.',
        email_terms:
            'Ik ga akkoord met de <a href="https://account.ecoflow.com/agreement/nl-nl/TermsOfUse.html" target="_blank">Gebruiksvoorwaarden</a> en het <a href="https://account.ecoflow.com/agreement/nl-nl/PrivacyPolicy.html" target="_blank">Privacybeleid</a>.',

        countdown_day: 'DAG',
        countdown_days: 'DAGEN',
        countdown_hour: 'UUR',
        countdown_hours: 'UREN',
        countdown_minute: 'MINUUT',
        countdown_minutes: 'MINUTEN',
        countdown_second: 'SECONDE',
        countdown_seconds: 'SECONDEN',

        card_sold: 'Verkocht: ',
        card_stock: 'Voorraad: ',
        card_btn_coming_soon: 'Binnenkort beschikbaar',
        card_btn_learn_more: 'Meer informatie',
        card_btn_buy_now: 'Nu kopen',
        card_btn_add_cart: 'In winkelwagen',
        card_btn_sold_out: 'Uitverkocht',
        card_inventory_left: '{num} over',
        card_tag_times: 'x',
        card_tag_point: ' EcoCredits',
        card_tag_off: ' KORTING',
        card_non_member_price: 'Prijs voor niet-leden',
        card_price_tax: '',
    },
};
